import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { PenDimensionPipeSegment } from 'models/pen/PenDimensionPipeSegment';
import { StandardValidationBuilder } from 'lib/validation';
import { ValidationController } from 'aurelia-validation';
import { PenDimensionPipeSegmentService } from 'services/pen/pen-dimension-pipe-segment-service';
import { ToastService } from 'services';

@autoinject
export class PenDimensionPipeSegmentCreate {
  private segmentIndexOptions = [];
  private form: { NewSegmentIndex: number } = { NewSegmentIndex: undefined };
  private penDimensionPipeId: number;

  constructor(
    private dialogController: DialogController,
    private ruleBuilder: StandardValidationBuilder,
    private validationController: ValidationController,
    private penDimensionPipeSegmentService: PenDimensionPipeSegmentService,
    private toastService: ToastService
  ) {}

  protected async activate(model: { data: PenDimensionPipeSegment[] }) {
    this.penDimensionPipeId = model.data[0].PenDimensionPipeId;
    model.data.forEach((e) => {
      this.segmentIndexOptions.push({ Name: e.Index, Id: e.Index });
    });
    this.segmentIndexOptions.push({ Name: this.segmentIndexOptions.length + 1, Id: this.segmentIndexOptions.length + 1 });

    this.createValidationRules();
  }

  async attached() {}

  @AsyncErrorHandler
  async createNewSegment() {
    const { valid } = await this.validationController.validate();
    if (valid) {
      await this.penDimensionPipeSegmentService.createPenDimensionPipeSegment(this.penDimensionPipeId, this.form.NewSegmentIndex);
      this.toastService.showSuccess('segment.created');
      await this.dialogController.cancel();
    }
  }

  private createValidationRules() {
    this.ruleBuilder.with(this.form).required('NewSegmentIndex').done();
  }
}
